import React from 'react'
import { AboutIcon, CloudEmptyIcon } from 'icons'

export const typeIconsMap = {
  cloud: <CloudEmptyIcon />,
  unit: <AboutIcon />,
}
